import { Routes } from "@angular/router";

export const bibleRoutes: Routes = [
  {
    path: 'bible',
    children: [
      {
        path: '',
        loadComponent: () => import('./views/bible-list-page/bible-list-page.component').then(m => m.BibleListPageComponent)
      },
      {
        path: ':translationId',
        redirectTo: ':translationId/genesis/1'
      },
      {
        path: ':translationId/:bookId',
        redirectTo: ':translationId/:bookId/1'
      },
      {
        path: ':translationId/:bookId/:chapter',
        loadComponent: () => import('./views/bible-chapter-page/bible-chapter-page.component').then(m => m.BibleChapterPageComponent)
      }
    ],
  },
];

export const bibleModalRoutes: Routes = [
  {
    path: 'find-translations',
    outlet: 'modal',
    loadComponent: () =>
      import('./views/find-translations-modal/find-translations-modal.component').then(
        (m) => m.FindTranslationsModalComponent
      ),
  },
  {
    path: 'quick-nav',
    outlet: 'modal',
    loadComponent: () =>
      import('./views/quick-nav-modal/quick-nav-modal.component').then(
        (m) => m.QuickNavModalComponent
      ),
  },
  {
    path: 'view-verse/:translationId/:bookId/:chapter/:verse',
    outlet: 'modal',
    loadComponent: () => import('./views/view-verse-modal/view-verse-modal.component').then(m => m.ViewVerseModalComponent)
  }
];